import { withPublicWrapper } from '../../components/public/Wrapper/withPublicWrapper';
import React from 'react';
import Head from 'next/head';
import AdminLogin from '../../components/private/Login/AdminLogin';
import Intro from '../../components/public/Intro/Intro';

const LoginPage = (): JSX.Element => {
  return (
    <>
      <Head>
        <title>Hitch and Hike - Login</title>
      </Head>
      <Intro
        title="Login"
        image={{ src: '/logo.png', alt: 'logo', width: '1779', height: '1608' }}
        descriptionText="Login as admin"
      />
      <AdminLogin url={'/admin/dashboard'} />
    </>
  );
};

export default withPublicWrapper(LoginPage);
